import {
    server
} from "@/api";

const prefix = 'api/auth';


export const login = async (user) => {
    return await server().post(`${prefix}/login`, user)
}

export const register = async (user) => {
    return await server().post(`${prefix}/register`, user);
}

export const visitorRegister = async (user) => {
    return await server().post(`${prefix}/visitor-register`, user);
}

export const verifyOtp = async (payload) => {
    return await server().post(`${prefix}/verify-otp`, payload);
}

export const resendOtp = async (payload) => {
    return await server().post(`${prefix}/resend-otp`, payload);
}

export const current = async () => {
    return await server().get(`${prefix}/current`)
}

export const logout = async () => {
    return await server().post(`${prefix}/logout`)
}

export const actAsRole = async (role) => {
    return await server().post(`${prefix}/act-as-role/${role}`)
}

export const validateResetToken = async (payload) => {
    return await server().post(`${prefix}/reset-password/validate`, payload);
}

export const resetPassword = async (payload) => {
    return await server().post(`${prefix}/reset-password`, payload);
}

export const requestPasswordReset = async (payload) => {
    return await server().post(`${prefix}/request-reset-password`, payload);
}

export default {
    login,
    register,
    visitorRegister,
    verifyOtp,
    resendOtp,
    current,
    logout,
    actAsRole,
    validateResetToken,
    resetPassword,
    requestPasswordReset
}